export const exportMethodsEnum = {
  MaexFtp: {
    method: 'maex_ftp',
    text: 'Maex'
  },

  Email: {
    method: 'email',
    text: 'Email versturen'
  }
}
